import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FilterOperator} from '@app/utils/filter-operator';
import {withDefaultAnomalyArchiveFilter} from '@app/pages/crop-monitoring/pages/anomalies/anomalies-archive-filter.util';
import {
  AnomaliesList,
} from '@app/pages/electronic-field-map/pages/gis-fields/components/modals/anomalies-dialog/anomalies-list/anomalies-list';

@Component({
  selector: 'app-field-details-anomalies-tab',
  standalone: true,
  imports: [CommonModule, AnomaliesList],
  templateUrl: './field-details-anomalies-tab.component.html',
  styleUrl: './field-details-anomalies-tab.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FieldDetailsAnomaliesTabComponent implements OnChanges {
  @Input({required: true}) fieldId!: string;

  appliedFilters: Object[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['fieldId']?.currentValue) {
      this.appliedFilters = withDefaultAnomalyArchiveFilter([
        {
          filterField: 'fieldId',
          filterOperator: FilterOperator.Equals,
          filterValue: this.fieldId,
        },
      ]);
    }
  }
}
